<!-- Иконка InfoFilled: сохранённый рисунок из карточки мониторинга. -->
<template>
  <svg
    :width="size"
    :height="size"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    :fill="stroke"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    />
  </svg>
</template>

<script>
export default {
  name: "InfoFilledIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
